type BannerResizeEntry = {
    borderBoxSize?: readonly { blockSize: number }[] | { blockSize: number };
    contentRect: { height: number };
};

type VerticalBoxStyle = Pick<CSSStyleDeclaration, "paddingTop" | "paddingBottom" | "borderTopWidth" | "borderBottomWidth">;

/** Use the observer's completed layout, not a new synchronous geometry read. */
export function consentBannerHeight(entry: BannerResizeEntry, readStyle: () => VerticalBoxStyle): number | null {
    const box = Array.isArray(entry.borderBoxSize)
        ? entry.borderBoxSize[0]
        : entry.borderBoxSize as { blockSize: number } | undefined;
    if (box && Number.isFinite(box.blockSize) && box.blockSize > 0) return box.blockSize;

    // Older implementations report only a content box. Add the actual locale-
    // and zoom-dependent padding/borders instead of assuming a fixed rem size.
    const contentHeight = entry.contentRect.height;
    if (!Number.isFinite(contentHeight) || contentHeight < 0) return null;
    const style = readStyle();
    const edges = [style.paddingTop, style.paddingBottom, style.borderTopWidth, style.borderBottomWidth];
    const height = edges.reduce((sum, edge) => {
        const value = Number.parseFloat(edge);
        return sum + (Number.isFinite(value) && value > 0 ? value : 0);
    }, contentHeight);
    return height > 0 ? height : null;
}
